export default __webpack_public_path__ + "static/media/aws-sme.fd180e6a.png";